import React, { useContext, useEffect, useState } from "react";
import HeaderNav from "../components/HeaderNav";
import Hero from "../components/Hero";
import Slider from "../components/Slider";
import FreeTips from "./FreeTips";
import { Link, useNavigate } from "react-router";
import PremiumTips from "./PremiumTips";
import Footer from "../components/Footer";
import { ToastContainer } from "react-toastify";
import AuthContext from "../global/auth-context";
import { Loader } from "../global/component";
import { Analytics } from "@vercel/analytics/react";

const Home = () => {
  const [freeTips, setFreeTips] = useState(true);
  const [premiumTips, setPremiumTips] = useState(false);

  let { fetchUserData, isLoading, SliderData, user } = useContext(AuthContext);

  let navigate = useNavigate();

  // if (!user) {
  //   return navigate("/login");
  // }

  return (
    <>
      <Analytics />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col justify-between h-full">
          <div>
            <HeaderNav page={"home"} />
            <Hero>
              <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
                <p className=" text-white font-bold text-5xl ">Green Luck</p>
                <div className="gap-3 flex">
                  <span className=" text-yellow-400 font-bold text-5xl">
                    Predictions
                  </span>
                  <span className=" text-white font-bold text-5xl">and</span>
                </div>
                <span className=" text-white font-bold text-5xl">Tips</span>
                <p className=" text-white font-normal text-xl w-2/3">
                  Users can get access to the free predictions without
                  registering, though registration are compulsory to get access
                  to the premium games.
                </p>
              </div>
              <div className="flex flex-col px-5 py-5 gap-7 h-full phone justify-center z-50">
                <div className="flex gap-3 flex-wrap">
                  <span className=" text-white font-bold text-3xl sm:w-full">
                    Green Luck
                  </span>

                  <span className=" text-yellow-400 font-bold text-3xl">
                    Predictions
                  </span>
                  <span className=" text-white font-bold text-3xl">and</span>
                  <span className=" text-white font-bold text-3xl">Tips</span>
                </div>
                <p className=" text-white font-normal sm:text-xl ">
                  Users can get access to the free predictions without
                  registering, though registration are compulsory to get access
                  to the premium games.
                </p>
              </div>
            </Hero>
            <Slider Slides={SliderData} />

            <div className="flex flex-1 bg-myLightGreen h-fit pb-10 flex-col">
              <div className="flex flex-col  py-5 items-center">
                <text className="w-screen text-center text-myNormalGreen font-bold text-3xl">
                  BET OF THE DAY
                </text>
                <text>
                  {new Date().toString().split(" ")[0] +
                    " - " +
                    new Date().toString().split(" ")[1] +
                    " " +
                    new Date().toString().split(" ")[2] +
                    " " +
                    new Date().toString().split(" ")[3]}
                </text>
              </div>
              <div className="flex w-screen justify-center">
                <div className="bg-white w-80 h-fit flex">
                  <Link
                    onClick={() => {
                      setFreeTips(true);
                      setPremiumTips(false);
                    }}
                    className={`${
                      freeTips ? "bg-myNormalGreen text-white " : ""
                    } p-3 w-1/2 text-center font-medium text-lg`}
                  >
                    Free Tips
                  </Link>
                  <Link
                    onClick={() => {
                      setPremiumTips(true);
                      setFreeTips(false);
                    }}
                    className={`${
                      premiumTips ? "bg-myNormalGreen text-white " : ""
                    } p-3 w-1/2 text-center font-medium text-lg`}
                  >
                    Premium Tips
                  </Link>
                </div>
              </div>
              {freeTips && <FreeTips />}
              {premiumTips && <PremiumTips />}
            </div>
          </div>

          <Footer />
        </div>
      )}
    </>
  );
};

export default Home;
